import { render, staticRenderFns } from "./ShopProductCheck.vue?vue&type=template&id=66f116f0&scoped=true&"
import script from "./ShopProductCheck.vue?vue&type=script&lang=js&"
export * from "./ShopProductCheck.vue?vue&type=script&lang=js&"
import style0 from "./ShopProductCheck.vue?vue&type=style&index=0&id=66f116f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f116f0",
  null
  
)

export default component.exports